import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { sortByProperties } from 'donor-elf-web/lib/array-utils';

export default class CampaignGoalExpectingController extends Controller {
  @tracked contactExpectingItemsSortBy: {
    property: string;
    direction: string;
  } = {
    property: 'totalExpecting',
    direction: 'desc',
  };

  get sortedContactExpectingItems() {
    return sortByProperties(this.model.contactExpectingItems, [
      `${this.contactExpectingItemsSortBy.property}:${this.contactExpectingItemsSortBy.direction}`,
    ]);
  }

  sortContactExpectingItemsBy = (sortProperty: string) => {
    if (sortProperty === this.contactExpectingItemsSortBy.property) {
      this.contactExpectingItemsSortBy = {
        property: sortProperty,
        direction:
          this.contactExpectingItemsSortBy.direction === 'asc' ? 'desc' : 'asc',
      };
    } else {
      this.contactExpectingItemsSortBy = {
        property: sortProperty,
        direction: 'asc',
      };
    }
  };
}
